.ux-iws-async-tab {
    width: 100%;
    display: none;

    &.is-active {
        display: block;

        // coming from patternlab, slider are set in tabs with margin bottomof 30px;
        .ux-slider {
            padding-bottom: 30px;
        }

        // fixes issues of contents with float
        &::after {
            content: "";
            display: table;
            clear: both;
        }
    }

    &.ux-iws-async-tab--with-slider {
        display: block;
        visibility: hidden;
        position: absolute;
        pointer-events: none;

        &.is-active {
            visibility: inherit;
            position: inherit;
            pointer-events: auto;
        }
    }
}
